"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoViewsInRange = exports.NoViewsYet = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./NoViews.css"));
var NoViewsYet = function (_a) {
    var pageStatus = _a.pageStatus, isPageEditable = _a.isPageEditable, renderSharePopover = _a.renderSharePopover;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.noViewsYet, justify: "center", align: "center", gap: "m" },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.iconCircle, justify: "center", align: "center" },
            react_1.default.createElement(icons_1.Analytics, { color: "primary" })),
        react_1.default.createElement(kaleidoscope_1.Heading, { level: "5" }, "No views yet"),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, noViewsYetMessage(pageStatus, isPageEditable)),
        (isPageEditable || pageStatus !== Types_1.ProjectStatus.Draft) && (react_1.default.createElement(kaleidoscope_1.Popover, { size: kaleidoscope_1.PopoverSize.Auto, position: kaleidoscope_1.PopoverPosition.Left, offset: 12, button: function (buttonProps) { return react_1.default.createElement(kaleidoscope_1.Button, __assign({}, buttonProps), "Share"); }, autoStack: true }, renderSharePopover()))));
};
exports.NoViewsYet = NoViewsYet;
function noViewsYetMessage(pageStatus, isPageEditable) {
    if (pageStatus !== Types_1.ProjectStatus.Draft) {
        return "Share this page to start seeing data.";
    }
    if (isPageEditable) {
        return "Set this page live and share to start seeing data.";
    }
    return "";
}
var NoViewsInRange = function () {
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.noViewsYet, justify: "center", align: "center", gap: "m" },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.iconCircle, justify: "center", align: "center" },
            react_1.default.createElement(icons_1.Analytics, { color: "primary" })),
        react_1.default.createElement(kaleidoscope_1.Heading, { level: "5" }, "No views in this time range")));
};
exports.NoViewsInRange = NoViewsInRange;
